import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { Editable, Slate, withReact } from 'slate-react';
import CodeToText from './Elements/CodeToText/CodeToText';
import Toolbar from './Toolbar/Toolbar';
import withEmbeds from './plugins/withEmbeds.js';
import withEquation from './plugins/withEquation.js';
import withLinks from './plugins/withLinks.js';
import withTables from './plugins/withTable.js';
import { getBlock, getMarked } from './utils/SlateUtilityFunctions.js';

const Element = (props) => {
  return getBlock(props);
};
const Leaf = ({ attributes, children, leaf }) => {
  children = getMarked(leaf, children);
  return <span {...attributes}>{children}</span>;
};
const SlateEditor = ({
  value = [
    {
      type: 'paragaph',
      children: [{ text: '' }],
    },
  ],
  setValue,
  header = <></>,
  footer = <></>,
  readOnly = false,
  bgColor,
}) => {
  const toolbarRef = useRef();
  const toolbarWrapperRef = useRef();
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [toolbarRef.current]);

  const handleScroll = () => {
    if (!toolbarWrapperRef.current || !toolbarRef.current) return;
    //detect if toolbarWrapper passed top of screen
    const isPassed = toolbarWrapperRef.current.getBoundingClientRect().top <= 0;

    if (isPassed) {
      //make toolbar width equal to toolbarWrapper width
      toolbarRef.current.style.width = toolbarWrapperRef.current.getBoundingClientRect().width + 'px';
      //make toolbarwrapper height equal to toolbar height
      toolbarWrapperRef.current.style.height = toolbarRef.current.getBoundingClientRect().height + 'px';
      toolbarRef.current.classList.add('fixed', 'top-0');
    } else {
      //change with to full
      toolbarRef.current.style.width = '100%';
      //change height to auto
      toolbarWrapperRef.current.style.height = 'auto';
      toolbarRef.current.classList.remove('fixed', 'top-0');
    }
  };

  const editor = useMemo(() => withEquation(withHistory(withEmbeds(withTables(withLinks(withReact(createEditor())))))), []);
  // const [value, setValue] = useState(value);

  const handleEditorChange = (newValue) => {
    if (readOnly) return;
    setValue(newValue);
  };

  const renderElement = useCallback((props) => <Element {...props} />, []);

  const renderLeaf = useCallback((props) => {
    return <Leaf {...props} />;
  }, []);

  const [htmlAction, setHtmlAction] = useState({
    showInput: false,
    html: '',
    action: '',
    location: '',
  });
  const handleCodeToText = (partialState) => {
    setHtmlAction((prev) => ({
      ...prev,
      ...partialState,
    }));
  };

  return (
    <div className='my-2 overflow-hidden rounded-2xl hover:border-t-primary-color border-t-border-color-base slate-wrapper'>
      <Slate editor={editor} value={value || []} onChange={handleEditorChange}>
        {!readOnly && (
          <div ref={toolbarWrapperRef}>
            <div className='z-50 border-b bg-t-bg-color editor-toolbar' ref={toolbarRef}>
              {header}
              <Toolbar handleCodeToText={handleCodeToText} />
            </div>
          </div>
        )}
        <div className={`w-full ${bgColor} ${readOnly ? 'rounded-2xl' : ''}`}>
          <div className='px-2 py-4 sm:px-4 lg:px-10'>
            <Editable readOnly={readOnly} placeholder='متن خود را وارد کنید.' renderElement={renderElement} renderLeaf={renderLeaf} className='min-h-[300px]' />
          </div>
        </div>
        {htmlAction.showInput && <CodeToText {...htmlAction} handleCodeToText={handleCodeToText} />}
      </Slate>
      {footer}
    </div>
  );
};

export default SlateEditor;
